// import external dependencies
import 'jquery';

// Import yarn modules
import 'flickity/dist/flickity.pkgd';
import 'flickity-fade/flickity-fade';
import 'flickity-imagesloaded/flickity-imagesloaded';

// Import everything from autoload
import './autoload/_foundation.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import about from './routes/about';
import blog from './routes/blog';
import support from './routes/support';
import singleProduct from './routes/single-product';
import templateStudioPortfolio from './routes/template-studio-portfolio';
import woocommerceCart from './routes/woocommerceCart';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  about,
  blog,
  support,
  templateStudioPortfolio,
  woocommerceCart,
  singleProduct,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js